import React from 'react';
import PropTypes from 'prop-types';
import { COLORS, COLOR, FONT_FAMILIES } from 'config';
import styled from 'styled-components';
import media from 'utils/media';

const Flex = styled.div`
  font-family: ${FONT_FAMILIES.sans};
  display: flex;
  flex-direction: column-reverse;
  font-size: 1.2rem;
  padding: 40px 0 40px 0;
  line-height: 150%;

  ${media.sm.css`
    flex-direction: row;
    font-size: 1.2rem;
  `}
`;

const Link = styled.a`
  width: 100%;
  color: ${COLORS.base};
  text-decoration: none;

  ${media.sm.css`
    width:70%;
  `}
`;

const Span = styled.span`
  width: 100%;
  color: ${COLOR.textGrey};
  text-decoration: none;

  ${media.sm.css`
    width:30%;
  `}
`;

const Hr = styled.hr`
  border: 0.5px solid #e6e6e6;
  margin: 0;
`;

const PressReleasesTable = ({ list }) => (
  <div>
    {
      list.map(({ title, link, dates }, i) => (
        <div key={i}>
          <Flex>
            <Link href={`/pressreleases/${link}`}>
              {title}
            </Link>
            <Span>
              {dates}
            </Span>
          </Flex>
          {(i !== 4 ? (<Hr />) : '')}
        </div>
      ))
    }
  </div>
);

PressReleasesTable.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    dates: PropTypes.string.isRequired,
  })),
};

PressReleasesTable.defaultProps = {
  list: [],
};

export default PressReleasesTable;



// WEBPACK FOOTER //
// ./src/components/PressReleases/components/PressReleasesTable.js